export default __webpack_public_path__ + "static/20211202_144532-3ff5ebd0a6cc76ef0108b85185ef38ee.jpeg";